import { render } from "./Emanta.vue?vue&type=template&id=011b43db"
import script from "./Emanta.vue?vue&type=script&lang=js"
export * from "./Emanta.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__